import { render, staticRenderFns } from "./ListagemDosBloqueiosDePagamentoPorCliente.vue?vue&type=template&id=09653039&"
import script from "./ListagemDosBloqueiosDePagamentoPorCliente.vue?vue&type=script&lang=ts&"
export * from "./ListagemDosBloqueiosDePagamentoPorCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports